import React from "react";
import { IconShare } from "components/Icon/IconShare";

interface SProps {
  size?: number;
  onShare?(): void;
}

export const ShareButton: React.FC<SProps> = ({ size = 24, onShare }) => {
  return (
    <a
      href="#"
      className="mr-0 ml-auto my-auto cursor-pointer"
      onClick={onShare}
    >
      <IconShare size={size} />
    </a>
  );
};
